import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND}/api`;

export const imgUrl = (src) => (!src ? "" : src.startsWith("/api/") ? `${BACKEND}${src}` : src);

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const track = (type) => axios.post(`${API}/track`, { type }).catch(() => {});

export const waLink = (wa) =>
  `https://wa.me/${String(wa?.number || "").replace(/\D/g, "")}?text=${encodeURIComponent(wa?.message || "")}`;

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
};

export const uid = () => Math.random().toString(36).slice(2, 12);
